export default "__VITE_ASSET__C8GMm3wu__"